// extracted by mini-css-extract-plugin
export default {"upcomingSchedule":"UpcomingEvents_upcomingSchedule__K6BuH"};